<template>
    <div class="pl-3 pr-3 pt-3">
        <AppPushNotification ref="notification" :title="notificationModel.title" :text="notificationModel.text"
            :color="notificationModel.color" />
        <template v-if="addresses.length > 0 && !loading">
            <template v-if="defaultAddress">
                <h5>{{ $t('default') }}</h5>
                <div class="address-box mb-4">
                    <div class="row pt-2 pb-2">
                        <div class="col-2 text-center h5"><i class="fi fi-rr-marker h4"></i></div>
                        <div class="col-8">
                            <h5>{{ defaultAddress.address }}</h5>
                            <span class="limited-text">{{ defaultAddress.location }}</span>
                            <span class="limited-text-one"> {{ defaultAddress.name + ' | ' + defaultAddress.phone
                                }}</span>
                        </div>
                        <div @click="editAddress(defaultAddress)" style="color: var(--bg-color-theme);"
                            class="col-2 h5">{{ $t('edit') }}</div>
                    </div>
                </div>
            </template>
            <template>
                <h5>{{ $t('savedAddress') }}</h5>
                <div v-for=" address  in  addresses " class="address-box mb-2">
                    <div class="row pt-2 pb-2">
                        <div class="col-2 text-center h5"><i class="fi fi-rr-marker h4"></i></div>
                        <div class="col-8">
                            <h5>{{ address.address }}</h5>
                            <span class="limited-text">{{ address.location }}</span>
                            <span class="limited-text-one"> {{ address.name + ' | ' + address.phone }}</span>
                        </div>
                        <div @click="editAddress(address)" style="color: var(--bg-color-theme);" class="col-2 h5">{{
            $t('edit') }}
                        </div>
                    </div>
                </div>
            </template>
            <div style="width: 100%;height: 100px;"></div>
        </template>
        <template v-else-if="addresses.length == 0 && !loading">
            <div style="position: fixed;width: 100%;top: 0;left: 0;height: 100%;background-color: white;"
                class="d-flex justify-content-center align-items-center">
                <div class="text-center m-4">
                    <img width="80%" class="mb-5" src="/img/address.png">
                    <h3>{{ $t('createNewAddress') }}</h3>
                    <span class="text-description">{{ $t('newAddressDespt') }}</span>
                </div>
            </div>
        </template>
        <CButton @click="createNewAddress()" class="mt-3 btn-color-theme fixed-bottom  m-3">{{
            $t('createNewAddress') }}
        </CButton>
        <template>
            <CModal style="color: #4f5d73;" :show.sync="showModal">
                <header class="header-delivery text-center">
                    <template>
                        <div @click="backwardState()">
                            <img width="13%" src="/left-arrow.png" style="position: fixed;left: 0;top: 0;margin: 1cap;">
                        </div>
                    </template>
                    <span class="mt-1 h4">{{ getHeader() }}</span>
                </header><br>
                <template>
                    <div class="location-picker-container mt-5">
                        <LocationPicker ref="location_app" @address-updated="updateAddress" />
                    </div>
                    <template v-if="state == 0" name="Pin Location State">
                        <div class="fixed-bottom p-4 address-form text-left">
                            <h4>{{ $t('pinLocation') }}</h4>
                            <span>{{ addressModel.location }}</span>
                            <CButton :disabled="addressModel.location == ''" @click="nextStage()" block
                                class="btn-color-theme bg-color-theme mt-4">
                                <template v-if="addressModel.location"> {{ $t('next') }} </template>
                                <template v-else> {{ $t('plsPinAddress') }} </template>
                            </CButton>
                        </div>
                    </template>
                    <transition name="fade" mode="out-in">
                        <template v-if="state == 1" name="Address Form Input State">
                            <div style="height: 70%;" class="fixed-bottom  address-form text-left">
                                <div class="form-input p-4 h5"
                                    style="height: calc(100% - 5px); overflow-y: auto; padding-bottom: 70px;">
                                    <div class="d-flex justify-content-between align-items-center mb-3">
                                        <h4 class="">{{ $t('inputAddressForm') }}</h4>
                                        <div class="text-right  h4 text-danger d-flex"
                                            @click="deleteAddress(addressModel)">
                                            <div class="pr-1"><i class="fi fi-rr-trash"></i></div> {{ $t('delete') }}
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <CSwitch class="pt-1" v-model="addressModel.isDefault" color="success"
                                            :value="addressModel.isDefault" :checked.sync="addressModel.isDefault" />
                                        &nbsp;<span>
                                            {{ $t('default') }}</span>
                                    </div>
                                    <div class="form-group">
                                        <small class="text-danger">*</small> <label for="name">{{ $t('receiverName')
                                            }}</label>
                                        <input type="text" id="name" v-model="addressModel.name"
                                            class="form-control-theme" :placeholder="''">
                                    </div>
                                    <div class="form-group">
                                        <small class="text-danger">*</small> <label for="address">{{ $t('location')
                                            }}</label>
                                        <input type="text" id="address" v-model="addressModel.location"
                                            class="form-control-theme limited-text">
                                    </div>
                                    <div class="form-group">
                                        <small class="text-danger">*</small>
                                        <label for="addressDetails">{{ $t('addressDescription') }}</label>
                                        <textarea id="addressDetails" v-model="addressModel.detail"
                                            class="form-control-theme"
                                            :placeholder="$t('addressDescriptionDespt')"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <small class="text-danger">*</small>
                                        <label for="addressDetails">{{ $t('tel') }}</label>
                                        <input type="tel" id="tel" v-model="addressModel.phone"
                                            class="form-control-theme" :placeholder="$t('ex') + ' 098 765 4321'">
                                    </div>
                                    <div class="form-group">
                                        <small class="text-danger">*</small>
                                        <label for="addressDetails">{{ $t('postalCode') }}</label>
                                        <input id="addressDetails" v-model="addressModel.postalCode"
                                            class="form-control-theme" :placeholder="$t('ex') + ' 30230'">
                                    </div>
                                    <div class="form-group">
                                        <label for="addressDetails">{{ $t('noteToDriver') }}</label>
                                        <textarea id="addressDetails" v-model="addressModel.note"
                                            class="form-control-theme"
                                            :placeholder="$t('noteToDriverDespt')"></textarea>
                                    </div>
                                    <div class="pt-1 " style="background-color: white;">
                                        <CButton block :disabled="loading" @click="saveAddress()"
                                            class="btn-color-theme bg-color-theme">
                                            <CSpinner v-if="loading" class="mb-1" component="span" size="sm"
                                                aria-hidden="true" />
                                            {{ $t('save') }}
                                        </CButton>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </transition>
                </template>
                <template #footer-wrapper>
                    <div></div>
                </template>
            </CModal>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import util from '@/util/util'
import '@/util/delivery.css'
import CModal from '@coreui/vue/src/components/modal/CModal'
import LocationPicker from '@/components/LocationPicker'
import { CButton } from '@coreui/vue'
import pos from '@/services/pos'
import AppPushNotification from '@/components/AppPushNotification.vue'
import moment from 'moment'


export default {
    components: {
        CModal,
        LocationPicker,
        AppPushNotification
    },
    data() {
        return {
            showModal: false,
            addressModel: {
                detail: '',
                isDefault: false,
                latlng: '',
                location: '',
                name: '',
                note: '',
                tel: '',
                postalCode: '',
            },
            state: 0,
            addresses: [],
            defaultAddress: [],
            option: '',
            notificationModel: {
                title: '',
                text: '',
                color: '',
            },
            loading: false,
        }
    },
    computed: {
        ...mapGetters(['shopLineOA']),
        token() {
            return localStorage.getItem('token') || null
        },
        uid() {
            return `${localStorage.getItem('uid')}`
        },
        shopObjectId() {
            return `${localStorage.getItem('shopObjectId')}`
        },
        shop() {
            return this.shopLineOA.find(
                (detail) => detail.objectId === this.shopObjectId
            )
        },
        shopName() {
            if (this.shop) {
                return this.shop.shopName
            } else {
                return ''
            }
        },
        validName() {
            return this.addressModel.name.trim() !== '';
        },
        validLocation() {
            return this.addressModel.location.trim() !== '';
        },
        validDetail() {
            return this.addressModel.detail.trim() !== '';
        },
        validPhone() {
            const phoneRegex = /^\d{10}$/;
            return phoneRegex.test(this.addressModel.phone);
        },
        validPostalCode() {
            const postalCodeRegex = /^\d{5}$/;
            return postalCodeRegex.test(this.addressModel.postalCode);
        }
    },
    created() {
        this.getAllUserAddress()
    },
    methods: {
        ...util,
        async getAllUserAddress() {
            this.loading = true
            try {
                if (localStorage.getItem('token')) {
                    const phone = localStorage.getItem('phone')
                    const uid = localStorage.getItem('uid')
                    const objectId = localStorage.getItem('objectId')

                    const res = await pos({
                        url: `/api/v1.3/${uid}/profile/addresses/${objectId}`,
                        method: 'get',
                        data: {
                            phone: phone,
                        }
                    });
                    if (res.data.error.code == 0) {
                        this.addresses = res?.data?.data || []
                        this.defaultAddress = this.addresses?.find((element) => element.isDefault == true) || {}
                        this.loading = false
                        localStorage.setItem('address', JSON.stringify(this.defaultAddress))
                    } else if (res.data.error.code == 402) {
                        this.renewToken()
                    } else if (res.data.error.code == 4000) {
                        this.logOut()
                    }
                }
            } catch (error) {
                console.error(error);
                this.loading = false
            }
        },
        async renewToken() {
            try {
                if (localStorage.getItem('refreshToken')) {
                    const refreshToken = localStorage.getItem('refreshToken')

                    let res = {}
                    res = await pos({
                        url: `/auth/v1.0/renewtoken/otp`,
                        method: 'post',
                        data: {
                            "refreshToken": refreshToken
                        }
                    });
                    if (res.data?.error?.code == 0) {
                        localStorage.setItem('token', res.data?.data?.token)
                        window.location.reload()
                    } else {
                        this.logOut()
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
        clearAddressModel() {
            this.addressModel = {
                detail: '',
                isDefault: false,
                latlng: '',
                location: '',
                name: '',
                note: '',
            }
        },
        async deleteAddress(address) {
            this.showModal = false
            if (this.option == 'edit') {
                try {
                    if (localStorage.getItem('token')) {
                        const uid = localStorage.getItem('uid')
                        const res = await pos({
                            url: `/api/v1.3/${uid}/profile/address/${address.objectId}`,
                            method: 'patch',
                            data: {
                                deleted_at: moment().toISOString()
                            }
                        });
                        if (res.data.error.code == 0) {
                            this.showNotification(this.$i18n.t('deleteAddressSuccess'), '', 'success')
                            this.getAllUserAddress()
                        } else if (res.data.error.code == 402) {
                            this.renewToken()
                            this.loading = false
                        } else if (res.data.error.code == 4000) {
                            this.logOut()
                        }
                    }
                } catch (error) {
                    this.showNotification(error, '', 'danger')
                    console.error(error);
                }
            }
            this.clearAddressModel()
            this.showModal = false
        },
        logOut() {
            const uid = localStorage.getItem('uid')
            const shopObjectId = localStorage.getItem('shopObjectId')
            sessionStorage.clear()
            localStorage.clear()
            localStorage.setItem('uid', uid)
            localStorage.setItem('shopObjectId', shopObjectId)
            this.$router.push('/delivery/home')
        },
        createNewAddress() {
            this.clearAddressModel()
            this.option = 'add'
            this.showModal = true
            this.$refs.location_app.getUserLocation()
        },
        editAddress(address) {
            this.option = 'edit'
            this.showModal = true
            this.nextStage()
            let position = {
                "coords": {
                    "latitude": parseFloat(address.lat),
                    "longitude": parseFloat(address.long),
                }
            }

            this.$refs.location_app.setCurrentLocation(position)
            this.addressModel = {
                name: address.name,
                location: address.location,
                phone: address.phone,
                detail: address.address,
                postalCode: address.postalCode,
                latlng: { lat: parseFloat(address.lat), lng: parseFloat(address.long) },
                isDefault: address.isDefault,
                phone: address.phone,
                note: address.note,
                objectId: address.objectId,
            }
            this.state = 1
            this.showModal = true
        },
        getHeader() {
            switch (this.option) {
                case 'edit':
                    return this.$i18n.t('editAddress')
                case 'add':
                    return this.$i18n.t('createNewAddress')
            }
        },

        backwardState() {
            if (this.state == 1) {
                this.$refs.location_app.setPickerHeight('90vh')
                this.state = 0
            } else {
                this.showModal = false
            }
        },
        async saveAddress() {
            this.loading = true
            const uid = localStorage.getItem('uid')
            const objectId = localStorage.getItem('objectId')
            let newAddress = {
                name: this.addressModel.name,
                location: this.addressModel.location,
                phone: this.addressModel.phone, // corrected to `phone` from `tel`
                detail: this.addressModel.detail,
                postalCode: this.addressModel.postalCode,
                latlng: this.$refs.location_app.getLatLong(),
                isDefault: this.addressModel.isDefault,
                note: this.addressModel.note,
                objectId: this.addressModel.objectId
            };
            const sendAddressData = async (url, method) => {
                if (localStorage.getItem('token') && this.formValidate()) {
                    try {
                        const res = await pos({
                            url,
                            method,
                            data: {
                                profileObjectId: objectId,
                                name: newAddress.name,
                                phone: newAddress.phone,
                                address: newAddress.detail,
                                postalCode: newAddress.postalCode,
                                location: newAddress.location,
                                lat: newAddress.latlng.lat.toString(),
                                long: newAddress.latlng.lng.toString(),
                                note: newAddress.note,
                                isDefault: newAddress.isDefault,
                                isDeliveryAddress: true,
                                isTaxAddress: true
                            }
                        });

                        if (res.data.error.code === 0) {
                            this.clearAddressModel();
                            this.showModal = false;
                            this.showNotification('บันทึกข้อมูลสำเร็จ', '', 'success');
                            this.loading = false
                        } else if (res.data.error.code == 402) {
                            this.renewToken()
                            this.loading = false
                        } else if (res.data.error.code == 4000) {
                            this.logOut()
                        }
                    } catch (error) {
                        this.showNotification('Error', error, 'danger');
                        console.error(error);
                        this.loading = false
                    }
                } else {
                    this.loading = false
                    this.showNotification('กรุณากรอกข้อมูลให้ถูกต้อง', '', 'warning')
                }
            };
            if (this.option === 'add') {
                await sendAddressData(`/api/v1.3/${uid}/profile/address`, 'post');
            } else if (this.option === 'edit') {
                await sendAddressData(`/api/v1.3/${uid}/profile/address/${newAddress.objectId}`, 'patch');
            }
            this.getAllUserAddress();
            window.scroll(0, 0);
        },
        nextStage() {
            this.state = 1
            this.$refs.location_app.setPickerHeight('20vh')
        },
        trackButtonClick(buttonLabel) {
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'click', {
                    event_label: buttonLabel,
                });
            } else {
                console.error('gtag is not defined.');
            }
        },
        updateAddress(newAddress) {
            this.addressModel.location = newAddress;
        },
        showNotification(title, text, color) {
            this.notificationModel = {
                color: color,
                title: title,
                text: text,
            }
            this.$refs.notification.pushNotification();
        },
        formValidate() {
            return this.validName && this.validLocation && this.validDetail && this.validPhone && this.validPostalCode;
        },
    },
    watch: {
    }
}
</script>